import checkURL from '@/helpers/checkURL'
import { LINK_TITLE_PLATFORM_ORIGINS } from '../config'

export const checkPlatformLink = (href?: string | null) => {
  if (!checkURL(href)) {
    return false
  }

  const { origin } = new URL(href as string)

  return LINK_TITLE_PLATFORM_ORIGINS.some((v) => v === origin)
}
